import { useState } from 'react';
import { SocialFeed } from '../../../components/social/SocialFeed';
import { NotificationCenter } from '../../../components/social/NotificationCenter';
import { StoriesBar } from '../../../components/social/StoriesBar';
import { DirectMessages } from '../../../components/social/DirectMessages';
import { FeedGamification } from '../../../components/social/FeedGamification';

export default function SocialPage() {
  const [showDM, setShowDM] = useState(false);
  const [showGamification, setShowGamification] = useState(false);

  return (
    <>
      {/* Stories Bar */}
      <div className="mb-4">
        <StoriesBar />
      </div>

      {/* Main Content - SocialFeed já inclui SearchAndFilters */}
      <div className="pb-8">
        <SocialFeed />
      </div>

      {/* Direct Messages Modal */}
      {showDM && <DirectMessages onClose={() => setShowDM(false)} />}

      {/* Feed Gamification Panel */}
      {showGamification && <FeedGamification onClose={() => setShowGamification(false)} />}
    </>
  );
}
